// Highlighted pickup-time range labels. Identical in SR and EN (numbers + "min").
const PICKUP_RANGE_LABELS = {
  "10_15": "10–15 min",
  "15_20": "15–20 min",
  "20_30": "20–30 min",
  "30_PLUS": "30+ min",
};

export const pickupRangeLabel = (range) =>
  PICKUP_RANGE_LABELS[range] || PICKUP_RANGE_LABELS["15_20"];
